export default "__VITE_ASSET__BOb6tDRE__"